import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./input.css";
import VueApexCharts from "vue3-apexcharts";
import "monaco-editor/min/vs/editor/editor.main.css";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "katex/dist/katex.min.css";
import { VueDatePicker } from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

const app = createApp(App);

const root = document.documentElement;
root.style.setProperty("--brand", process.env.VUE_APP_BRAND_COLOR);
root.style.setProperty("--button", process.env.VUE_APP_BUTTON_COLOR);
root.style.setProperty("--buttonHover", process.env.VUE_APP_BUTTON_HOVER);
root.style.setProperty(
  "--brandHoverText",
  process.env.VUE_APP_BRAND_TEXT_COLOR
);

// GLOBAL THEME (ADD THIS)
// app.config.globalProperties.$theme = {
//   brand: process.env.VUE_APP_BRAND_COLOR,
//   second: process.env.VUE_APP_SECOND_BRAND_COLOR,
//   button: process.env.VUE_APP_BUTTON_COLOR,
//   buttonHover: process.env.VUE_APP_BUTTON_HOVER,
// };

// plugins
app.use(VueApexCharts);
app.component("VueDatePicker", VueDatePicker);

app.use(store);
app.use(router);

app.mount("#app");
